import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    width: fit-content;\n\n    ", " {\n        top: 35px;\n    }\n\n    ", " {\n        outline: 0 !important;\n        border: none !important;\n        box-shadow: unset !important;\n        padding: 0;\n        margin: 0;\n\n        color: ", ";\n        font-weight: ", ";\n        font-size: 16px;\n\n        font: ", ";\n        color: ", ";\n        text-align: center;\n        width: 100%;\n\n        &::placeholder {\n            color: ", ";\n        }\n\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    ", " {\n        display: flex;\n        text-align: start;\n        margin: 0;\n        padding: ", ";\n        border-bottom: 1px solid ", " !important;\n    }\n\n    ", " {\n        text-align: center;\n    }\n\n    ", " {\n        color: ", ";\n\n        font-weight: ", " !important;\n        position: relative;\n        right: 0;\n        top: 0;\n        margin-left: auto;\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    width: ", ";\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Select } from '../Select';
import { RawInput } from '../InputText/RawInput';
import { Icon } from '../Icon';
export var StyledWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.components.displayInput.width;
});
export var StyledSelect = styled(Select)(_templateObject2(), Select.Styles.StyledOptions, RawInput.Styles.StyledInput, function (props) {
  return props.theme.global.colors.primary;
}, function (props) {
  return props.theme.global.typographyConfig.fontWeight.semibold;
}, function (props) {
  return props.theme.global.typographyConfig.headings.h2.font;
}, function (props) {
  return props.disabled ? props.theme.global.colors.porcelainDarker : props.theme.global.colors.primary;
}, function (props) {
  return props.theme.global.colors.porcelainDarker;
}, RawInput.Styles.StyledLabelWrapper, function (props) {
  return props.theme.components.displayInput.padding;
}, function (props) {
  return props.theme.global.colors.porcelainDarker;
}, RawInput.Styles.StyledMessage, Icon.Styles.StyledIcon, function (props) {
  return props.disabled ? props.theme.global.colors.porcelainDarker : props.theme.global.colors.primary;
}, function (props) {
  return props.theme.global.typographyConfig.fontWeight.bold;
});